'use client';
// Modules
import React from 'react';
import { useRouter } from 'next/navigation';
import { Container } from 'react-bootstrap';
import Link from 'next/link';

// Styles
import './styles.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './regulatory.module.scss';

const Regulatory = () => {
  const router = useRouter();

  return (
    <div className={styles.container}>
      <Container fluid className={`grey_text extra_sides_padding ${styles.container_margin}`}>
        <h1 className="heading_text light_black_text">
          <span className="primary_orange_text">Regulatory</span>
        </h1>
        <p className="paragraph_text">
          Trio is committed to compliance. We care deeply about upholding every regulatory standard.
        </p>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Annual Financial Statements
        </h4>
        {/* <p className="paragraph_text grey_text">
          Trio holds itself accountable. Our annual financial statements reflect
          our commitment to honesty and sound financial stewardship.
        </p> */}
        <ul>
          <li>
            <Link
              href="https://triotech-website.famapp.co.in/VFRfQW5udWFsIFJldHVybiBGWSAyMDI0LTI1.pdf"
              target="_blank"
            >
              Annual Return FY 2024-25
            </Link>
          </li>
          <li>
            <Link
              href="https://triotech-website.famapp.co.in/VFRfQW5udWFsIFJldHVybiBGWSAyMDIzLTI0.pdf"
              target="_blank"
            >
              Annual Return FY 2023-24
            </Link>
          </li>
        </ul>

        <h4 className={`subheading_text light_black_text ${styles.subheading}`}>
          Reserve Bank - Integrated Ombudsman Scheme, 2026
        </h4>
        {/* <p className="paragraph_text grey_text">
          Trio is committed to resolving every customer concern fairly and
          promptly. Where a grievance remains unresolved, customers may escalate
          under the Reserve Bank – Integrated Ombudsman Scheme, 2026.
        </p> */}
        <ul>
          <li>
            <Link
              href="https://rbidocs.rbi.org.in/rdocs/content/pdfs/SCHEME16012026_A.pdf"
              target="_blank"
            >
              Integrated Ombudsman Scheme, 2026
            </Link>
          </li>
        </ul>
      </Container>
    </div>
  );
};

export default Regulatory;
